import { Component, OnInit, Inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EventDetail } from 'app/events/events';
import { ToolsService } from 'app/_services/tools.service';

@Component({
    selector: 'app-edit-event-detail-dialog',
    templateUrl: './edit-event-detail-dialog.component.html',
    styleUrls: ['./edit-event-detail-dialog.component.scss'],
})
export class EditEventDetailDialogComponent implements OnInit {
    title = 'Event Detail Editor';
    eventDetail: EventDetail;
    eventDetailEditorForm: FormGroup;
    eventName: string;
    disabled: boolean = false;
    disabledSubtitle: boolean = true;

    // Getters for form validation error messages
    get startDate(): AbstractControl {
        return this.eventDetailEditorForm.controls.startDate;
    }
    get endDate(): AbstractControl {
        return this.eventDetailEditorForm.controls.endDate;
    }
    // get startTime(): AbstractControl { return this.eventDetailEditorForm.controls.startTime; }
    // get endTime(): AbstractControl { return this.eventDetailEditorForm.controls.endTime; }
    get subtitle(): AbstractControl {
        return this.eventDetailEditorForm.controls.subtitle;
    }
    get subtitleActive(): AbstractControl {
        return this.eventDetailEditorForm.controls.subtitleActive;
    }

    constructor(
        private dialogRef: MatDialogRef<EditEventDetailDialogComponent>,
        private toolsService: ToolsService,
        private formBuilder: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.eventDetail = data.eventDetail;
        this.eventName = data.eventName;
    }

    ngOnInit(): void {
        if (this.eventDetail.startDate && !this.eventDetail.endDate) {
            this.disabled = true;
        }

        this.disabledSubtitle = this.eventDetail.subtitle === null || this.eventDetail.subtitle === '' || this.eventDetail.subtitle.length === 0;

        this.eventDetailEditorForm = this.formBuilder.group(
            {
                startDate: [this.eventDetail.startDate, [Validators.required]],
                endDate: [{ value: this.eventDetail.endDate, disabled: this.disabled }, [Validators.required]],
                // startTime: [this.eventDetail.startTime],
                // endTime: [this.eventDetail.endTime],
                cancelled: [this.eventDetail.cancelled],
                tentative: [this.eventDetail.tentative],
                allDay: [this.disabled],
                location: [this.eventDetail.location],
                subtitle: [this.eventDetail.subtitle || ''],
                subtitleActive: [{value: this.eventDetail.subtitleActive, disabled: this.disabledSubtitle }],
            },
            {
                validators: [dateTimeValidator('allDay', 'startDate', 'endDate', 'endDateInvalid')],
                updateOn: 'blur',
            }
        );

        this.eventDetailEditorForm.get('subtitle').valueChanges.subscribe(v => {
            if(!v) this.subtitleActive.disable();
            else this.subtitleActive.enable();
        });

        this.title = this.data.title;
    }

    onToggleAllDay(event) {
        event.checked ? this.endDate.disable() : this.endDate.enable();
    }

    onNoClick(): void {
        this.dialogRef.close(null);
    }

    onSubmit(formValues): void {
        const startDate = new Date(formValues.startDate);
        const endDate = new Date(formValues.endDate);
        const subtitleActive = formValues.subtitleActive ?? false;

        this.eventDetailEditorForm.markAllAsTouched();

        if (this.eventDetailEditorForm.valid) {
            this.eventDetail.startDate = this.toolsService.toISOLocal(startDate);
            this.eventDetail.endDate = this.endDate.disabled ? null : this.toolsService.toISOLocal(endDate);
            // this.eventDetail.startTime = formValues.startTime;
            // this.eventDetail.endTime = formValues.endTime;
            this.eventDetail.location = formValues.location;
            this.eventDetail.cancelled = formValues.cancelled;
            this.eventDetail.tentative = formValues.tentative;
            this.eventDetail.subtitle = formValues.subtitle;
            this.eventDetail.subtitleActive = subtitleActive;
            this.dialogRef.close(this.eventDetail);
            this.eventDetailEditorForm.reset();
        }
    }
}

// Validation function to make sure that end date is not before the start date for the given event.
function dateTimeValidator(allDay: string, start: string, end: string, errorProperty: string): ValidatorFn {
    return (group: FormGroup): ValidationErrors | null => {
        const dateTimeStart = group.controls[start].value;
        const dateTimeEnd = group.controls[end].value;
        const disabled = group.controls[allDay].value;

        const error = dateTimeStart > dateTimeEnd && !disabled ? { [errorProperty]: true } : null;
        return error;
    };
}
